module.exports = __webpack_public_path__ + "stats.efbc03a1.mp4";